import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { PaymentMethodGeneralLimit } from '@/models/ps-management/exception-limit.model';

export default
class GetPaymentMethodGeneralLimitListRequest extends ApiResourceMethod<PaymentMethodGeneralLimit[]> {
  public perform(paymentMethodId: string): Promise<PaymentMethodGeneralLimit[]> {
    return this.performer.requestWithMapper(
      { url: `paymentMethodSettings/${paymentMethodId}/generalLimit` },
      (payload: BaseResponse<PaymentMethodGeneralLimit[]>): PaymentMethodGeneralLimit[] => {
        return payload.data;
      },
    );
  }
}
